export default "<input type=\"file\" (change)=\"handleUpload($event)\" /> <br /><br />\n<button (click)=\"inviaEmail()\">Invia</button>\n"